import React from 'react';

/**
 * Displays a Requisition's resubmittal order# or XCOM id value
 * 
 * @param props.value The value to display
 */
export default function XcomID({ value }) {
	if (!value) {
		return null;
	}

	if (value === 'Not Provided') {
		return <span>To Complete Recollection: Unknown Order</span>;
	}

	return <span>To Complete Order: {value}</span>;
}
